const nbspRegex = new RegExp(String.fromCharCode(160), "g");

// replace '&nbsp;' symbol to regular (breaking) space
export const processNbspInMarkdown = (rawText: string): string => {
  return rawText.replace(nbspRegex, " ");
};
